import { createFileRoute } from "@tanstack/react-router";
import BenagilLanding, { BENAGIL_FAQS } from "@/components/BenagilLanding";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";

const TITLE =
  "Benagil Caves Portugal — Private Tour from Vilamoura | Morningstar Yacht";
const DESC =
  "Visit the Benagil caves on Portugal's Algarve coast by private yacht from Vilamoura Marina. Skip the crowds, snorkel and paddleboard included. Book on WhatsApp.";
const PATH = "/benagil-cave-tour";
const URL = `${SITE_URL}${PATH}`;
const OG_IMAGE = `${SITE_URL}/og/benagil-cave-tour.jpg`; // [DÚVIDA: generate a dedicated OG image] — falls back to default share image set in localBusinessLD

function benagilFaqLD() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: BENAGIL_FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

function touristAttractionLD() {
  return {
    "@context": "https://schema.org",
    "@type": "TouristAttraction",
    name: "Algar de Benagil",
    description:
      "The Algar de Benagil is one of the most iconic sea caves in the world, on Portugal's Algarve coast — famous for the natural oculus in its ceiling. Reachable only by sea.",
    image: OG_IMAGE,
    touristType: ["Couples", "Families", "Groups", "Photography"],
    geo: { "@type": "GeoCoordinates", latitude: 37.0876, longitude: -8.4275 },
    address: {
      "@type": "PostalAddress",
      addressLocality: "Lagoa",
      addressRegion: "Algarve",
      addressCountry: "PT",
    },
  };
}

export const Route = createFileRoute("/benagil-cave-tour")({
  component: BenagilLanding,
  head: () => {
    const head = buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "benagil caves portugal, benagil caves algarve, caves of benagil portugal, benagil cave tour, algar de benagil, benagil cave tour from vilamoura, private benagil tour, algarve cave tour",
      altPath: { en: PATH, pt: "/pt/gruta-de-benagil" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Benagil Cave Tour from Vilamoura",
              description: DESC,
              url: URL,
              itinerary:
                "Vilamoura Marina → São Rafael → Senhora da Rocha → Triumph Arch → Submarine Beach → Benagil Cave → private beach swim → return.",
            }),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(touristAttractionLD()) },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Benagil Cave Tour", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(benagilFaqLD()) },
      ],
    });
    return head;
  },
});